"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.StyledModal = exports.Header = exports.Footer = exports.Core = exports.Content = exports.Close = exports.Background = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactAnimations = require("react-animations");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const incomingAnimation = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), _reactAnimations.pulse);

const StyledModal = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 9997;\n  ", ";\n"])), _ref => {
  var _theme$components, _theme$components$mod;

  let {
    theme
  } = _ref;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$mod = _theme$components.modal) === null || _theme$components$mod === void 0 ? void 0 : _theme$components$mod.modal;
});

exports.StyledModal = StyledModal;

const Background = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  z-index: 9998;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0px;\n  left: 0px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  background: rgba(0, 0, 0, 0.3);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  ", ";\n"])), _ref2 => {
  var _theme$components2, _theme$components2$mo;

  let {
    theme
  } = _ref2;
  return theme === null || theme === void 0 ? void 0 : (_theme$components2 = theme.components) === null || _theme$components2 === void 0 ? void 0 : (_theme$components2$mo = _theme$components2.modal) === null || _theme$components2$mo === void 0 ? void 0 : _theme$components2$mo.background;
});

exports.Background = Background;

const Core = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 9999;\n  background-color: ", ";\n  box-shadow: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  animation: 0.25s ", ";\n  border-radius: ", ";\n  overflow: hidden;\n  @media (min-width: ", ") {\n    width: 750px;\n  }\n  @media (min-width: ", ") {\n    width: calc(100vw - 60px);\n    margin: 0px;\n    width: 970px;\n  }\n  @media (min-width: ", ") {\n    width: 1170px;\n  }\n  ", ";\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.color.background.primary;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.shadow;
}, incomingAnimation, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.border.radius;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.breakpoint.sm;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.breakpoint.md;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.breakpoint.lg;
}, _ref9 => {
  var _theme$components3, _theme$components3$mo;

  let {
    theme
  } = _ref9;
  return theme === null || theme === void 0 ? void 0 : (_theme$components3 = theme.components) === null || _theme$components3 === void 0 ? void 0 : (_theme$components3$mo = _theme$components3.modal) === null || _theme$components3$mo === void 0 ? void 0 : _theme$components3$mo.core;
});

exports.Core = Core;

const Header = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  align-items: center;\n  padding: 15px;\n  box-sizing: border-box;\n  width: inherit;\n  border-bottom: thin solid ", ";\n  ", ";\n"])), _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.color.background.primary;
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.color.border.primary;
}, _ref12 => {
  var _theme$components4, _theme$components4$mo;

  let {
    theme
  } = _ref12;
  return theme === null || theme === void 0 ? void 0 : (_theme$components4 = theme.components) === null || _theme$components4 === void 0 ? void 0 : (_theme$components4$mo = _theme$components4.modal) === null || _theme$components4$mo === void 0 ? void 0 : _theme$components4$mo.header;
});

exports.Header = Header;

const Title = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  flex: 1 1 0px;\n  ", ";\n"])), _ref13 => {
  var _theme$components5, _theme$components5$mo;

  let {
    theme
  } = _ref13;
  return theme === null || theme === void 0 ? void 0 : (_theme$components5 = theme.components) === null || _theme$components5 === void 0 ? void 0 : (_theme$components5$mo = _theme$components5.modal) === null || _theme$components5$mo === void 0 ? void 0 : _theme$components5$mo.title;
});

exports.Title = Title;

const Close = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", ";\n"])), _ref14 => {
  var _theme$components6, _theme$components6$mo;

  let {
    theme
  } = _ref14;
  return theme === null || theme === void 0 ? void 0 : (_theme$components6 = theme.components) === null || _theme$components6 === void 0 ? void 0 : (_theme$components6$mo = _theme$components6.modal) === null || _theme$components6$mo === void 0 ? void 0 : _theme$components6$mo.close;
});

exports.Close = Close;

const Content = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: 15px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  max-height: 70vh;\n  box-sizing: border-box;\n  ", ";\n"])), _ref15 => {
  var _theme$components7, _theme$components7$mo;

  let {
    theme
  } = _ref15;
  return theme === null || theme === void 0 ? void 0 : (_theme$components7 = theme.components) === null || _theme$components7 === void 0 ? void 0 : (_theme$components7$mo = _theme$components7.modal) === null || _theme$components7$mo === void 0 ? void 0 : _theme$components7$mo.content;
});

exports.Content = Content;

const Footer = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  width: inherit;\n  border-top: thin solid ", ";\n  padding: 15px;\n  ", ";\n"])), _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.color.background.primary;
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.color.border.primary;
}, _ref18 => {
  var _theme$components8, _theme$components8$mo;

  let {
    theme
  } = _ref18;
  return theme === null || theme === void 0 ? void 0 : (_theme$components8 = theme.components) === null || _theme$components8 === void 0 ? void 0 : (_theme$components8$mo = _theme$components8.modal) === null || _theme$components8$mo === void 0 ? void 0 : _theme$components8$mo.footer;
});

exports.Footer = Footer;